import { createStyles, rem } from '@asuikit/styles';

export default createStyles({
  // required to allow dropdown padding override with styles and classNames
  dropdown: { padding: rem(10) },
});
